import styled from '@emotion/styled';
import { Icon } from '../../../../../components-dummy';

export const IconStyled = styled(Icon)`
  path {
    stroke: ${({ theme }) => theme.palette.custom['gray-20']};
  }
`;
